import script from "./CancelButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CancelButton.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__